export function MigLogo() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 15" className="w-[53px] h-[15px]">
      <path
        fill="#0F754E"
        d="M0 0h4.95c.45 0 1.8-.15 2.4 1.95a193 193 0 0 1 1.95 6.6h.3c.9-3.3 1.65-5.55 1.95-6.6.6-2.1 2.1-1.95 2.7-1.95h4.65v14.4h-4.8V5.85h-.3l-2.55 8.55h-3.6L5.1 5.85h-.45v8.55H0M20.85 0h4.8v8.55h.45l3.15-7.05A2.6 2.6 0 0 1 31.2 0h4.5v14.4h-4.8V5.85h-.3l-3.15 7.05c-.6 1.35-2.1 1.5-2.1 1.5h-4.5"
      />
      <path
        fill="#fff"
        d="M0 0h4.95c.45 0 1.8-.15 2.4 1.95a193 193 0 0 1 1.95 6.6h.3c.9-3.3 1.65-5.55 1.95-6.6.6-2.1 2.1-1.95 2.7-1.95h4.65v14.4h-4.8V5.85h-.3l-2.55 8.55h-3.6L5.1 5.85h-.45v8.55H0M20.85 0h4.8v8.55h.45l3.15-7.05A2.6 2.6 0 0 1 31.2 0h4.5v14.4h-4.8V5.85h-.3l-3.15 7.05c-.6 1.35-2.1 1.5-2.1 1.5h-4.5"
      />
      <path fill="#0F754E" d="M43.15 10.05v4.35h-5.5V6.9h5.5v3.15Z" />
      <path fill="#fff" d="M43.15 10.05v4.35h-5.5V6.9h5.5v3.15Z" />
      <path fill="url(#mig-a)" d="M37.46 6c-.6-2.7 1.2-6 5.1-6h10.2c-.3 3.15-3 6-5.85 6" />
      <defs>
        <linearGradient
          id="mig-a"
          x1="39.26"
          x2="51.26"
          y1="-1.95"
          y2="-1.95"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#9C9C9C" />
        </linearGradient>
      </defs>
    </svg>
  );
}
